import { createContext, useContext, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const WizardHeaderContext = /*#__PURE__*/createContext(undefined);
export const WizardHeaderProvider = ({
  sectionStyleOverrides,
  stepIndicatorStyleOverrides,
  children
}) => {
  const value = useMemo(() => ({
    sectionStyleOverrides,
    stepIndicatorStyleOverrides
  }), [sectionStyleOverrides, stepIndicatorStyleOverrides]);
  return /*#__PURE__*/_jsx(WizardHeaderContext.Provider, {
    value: value,
    children: children
  });
};

/**
 * Provides the context for the `WizardHeader` component.
 * Note: The context is only available when the `WizardHeader` component is rendered as an ancestor.
 * @returns WizardHeaderContext - The context for the `WizardHeader` component.
 * @returns WizardHeaderContext.sectionStyleOverrides - Style overrides to be applied to the `Section` component.
 * @returns WizardHeaderContext.stepIndicatorStyleOverrides - Style overrides to be applied to the `StepIndicator` component.
 */
export const useWizardHeaderContext = () => {
  return useContext(WizardHeaderContext);
};